<style lang="scss" scoped>

.MobiWatermarkBackground{
    position:fixed;
    padding:0;
    margin:0;
    top:0;
    left:0;
    background:rgba(255,255,255,0.5);
    flex: 1;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    @media only screen and (max-width: 768px) {
      padding-top: 12px;
      text-align: center;
    }
    &__Watermark{
        display: block;
        margin-left: auto;
        margin-right: auto;
        transform: scale(1.5);
        -webkit-transform:scale(1.5);
        max-width: 50%;

       @media
        (-webkit-min-device-pixel-ratio: 2),
        (min-resolution: 192dpi) {
        transform: scale(1);
        -webkit-transform:scale(1);

        }
    }
}
</style>


<template lang="pug">
    .MobiWatermarkBackground: img.image.MobiWatermarkBackground__Watermark(src="@/assets/img/mobi_logo_large.png" alt="Mobi Lab Logo")

</template>

<script>
  export default {
    name: 'MobiWatermarkBackground',
  };
</script>



// WEBPACK FOOTER //
// src/components/MobiWatermarkBackground.vue